import { render, staticRenderFns } from "./AlarmStatus.vue?vue&type=template&id=2425ed1a&scoped=true&"
import script from "./AlarmStatus.vue?vue&type=script&lang=js&"
export * from "./AlarmStatus.vue?vue&type=script&lang=js&"
import style0 from "./AlarmStatus.vue?vue&type=style&index=0&id=2425ed1a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2425ed1a",
  null
  
)

export default component.exports